module.exports = __webpack_public_path__ + "img/medcube_top2.b2f3cafe.jpg";